import { HashRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Layout from "./Common/Layout/Layout";
import Home from "./Pages/Home/Home";
import ContactUs from "./Pages/ContactUs/ContactUs";
import { useEffect, useRef } from "react";
import "@fontsource/metropolis/100.css";
import "@fontsource/metropolis/200.css";
import "@fontsource/metropolis/300.css";
import "@fontsource/metropolis/400.css";
import "@fontsource/metropolis/500.css";
import OperationalRisk from "./Pages/SolutionPages/OperationalRisk/OperationalRisk";
import BusinessContinuity from "./Pages/SolutionPages/BusinessContinuity/BusinessContinuity";
import RiskManagement from "./Pages/SolutionPages/RiskManagement/RiskManagement";
import AiGovernance from "./Pages/SolutionPages/AiGovernance/AiGovernance";
import ProcessRisks from "./Pages/SolutionPages/ProcessRisks/ProcessRisks";
import AboutUs from "./Pages/AboutUs/AboutUs";
import { ScrollProvider } from "./ScrollContext";
import Careers from "./Pages/Careers/careers";
import Insights from "./Pages/Insights/Insights";
import Blog from "./Pages/Insights/Blog/Blog";
import FactSheetDownload from "./Pages/Insights/DownloadFactsheet/FactSheetDownload";
import Clients from "./Pages/Clients/Clients";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SubsCribeBanner from "./Pages/Insights/Components/SubscribeBanner/SubsCribeBanner";
import RegPulseSignupActivation from "./Pages/RegPulseSignupActivation/RegPulseSignupActivation";
import RegPulseFeedback from "./Pages/RegPulseFeedback/RegPulseFeedback";
import RegPulseLinkExpire from "./Pages/RegPulseLinkExpire/RegPulseLinkExpire";
import RegPulseUnsubscribe from "./Pages/RegPulseUnsubscribe/RegPulseUnsubscribe";
import FailedUnsubscrbe from "./Pages/FailedUnsubscrbe/FailedUnsubscrbe";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import TermsOfUse from "./Pages/TermsOfUse/TermsOfUse";
import VerifyMail from "./Pages/VerifyMail/VerifyMail";
import Unsubscribe from "./Pages/Unsubscribe/Unsubscribe";
import { initializeGA } from "./config/googleAnalytics";
function App() {

 useEffect(() => {
        const consent = localStorage.getItem("analyticsConsent");
        if (consent === "true") {
          console.log("analytics trigerred BK!!!!!")
            initializeGA();
        }

    }, []);

  return (
    <Router>
      <ScrollProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="home" replace />} />
            <Route index path="home" element={<Home />} />
            <Route index path="about" element={<AboutUs />} />
            <Route index path="client" element={<Clients />} />
            <Route index path="contact" element={<ContactUs />} />
            <Route index path="careers" element={<Careers />} />
            <Route
              path="regpulsesignupactivation"
              element={<RegPulseSignupActivation />}
            />
            <Route path="regpulseunsubscribe" element={<RegPulseUnsubscribe />} />
            <Route path="regpulseunsubscribeerror" element={<FailedUnsubscrbe />} />
            <Route path="regpulselinkexpire" element={<RegPulseLinkExpire />} />
            <Route path="regpulsefeedback" element={<RegPulseFeedback />} />
            <Route path="regpulsefeedback/:token" element={<RegPulseFeedback />} />
            <Route path="verifymail" element={<VerifyMail />} />
            <Route path="verifymail/:token" element={<VerifyMail />} />
            <Route path="verifyemail" element={<VerifyMail />} />
            <Route path="verifyemail/:token" element={<VerifyMail />} />
            <Route path="unsubscribe" element={<Unsubscribe />} />
            <Route path="unsubscribe/:token" element={<Unsubscribe />} />
            <Route path="regpulseprivacypolicy" element={<PrivacyPolicy />} />
            <Route path="regpulsetermsofuse" element={<TermsOfUse />} />
            <Route
              index
              path="solutions"
              element={<Navigate to="/solutions/operationalrisk" replace />}
            />
            <Route path="subscribe" element={<SubsCribeBanner />} />
            <Route
              index
              path="solutions/operationalrisk"
              element={<OperationalRisk />}
            />
            <Route
              index
              path="solutions/businesscontinuity"
              element={<BusinessContinuity />}
            />
            <Route
              index
              path="solutions/riskmanagement"
              element={<RiskManagement />}
            />
            <Route
              index
              path="solutions/aigovernance"
              element={<AiGovernance />}
            />
            <Route
              index
              path="solutions/processrisks"
              element={<ProcessRisks />}
            />
            {/* <Route path="/insights" element={<Insights />} /> */}
            <Route path="/insights/:type" element={<Insights />} />
            <Route
              path="/insights/factsheet/download"
              element={<FactSheetDownload />}
            />
            <Route path="/insights/blog/content/:blogname" element={<Blog />} />
          </Route>
        </Routes>
      </ScrollProvider>
    </Router>
  );
}

export default App;
